module.exports = __webpack_public_path__ + "img/green.e4c5afb6.svg";